import React, { forwardRef, lazy, Suspense } from 'react';
import { useLocale } from '../hooks/router';

const ReCAPTCHA = lazy(() => import('react-google-recaptcha'));

// Hoisted out of the parameter default: the React Compiler cannot prove an
// inline arrow written as a default value is safe to reorder, and bails out of
// the whole component rather than memoize it.
const identity = x => x;

// The ref exposes the widget's imperative API, of which the caller needs
// reset(): a solved checkbox never fires onChange again, so it is the only way
// back to an unsolved widget once the token it handed over has been used.
export const Captcha = forwardRef(({ callback = identity }, ref) => {
  const locale = useLocale();

  return (
    <Suspense>
      <ReCAPTCHA
        ref={ref}
        theme={'light'}
        sitekey={window.CONFIG.captchaSiteKey}
        onChange={callback}
        hl={locale}
      />
    </Suspense>
  );
});
